import gsap from 'gsap/gsap-core';

export default function SocialShare() {
	let socialButton = $('.social-share');
	if (socialButton.length > 0) {
		socialButton.on('click', function () {
			$('.introBlock__shareDiv').toggleClass('introBlock__shareDiv--open');
		});
	}

	let copyButton = $('.share-copy');
	$('.introBlock__copyConfirm').hide();
	if (copyButton.length > 0) {
		copyButton.on('click', function () {
			let url = window.location.href;
			let input = document.createElement('input');
			input.setAttribute('value', url);
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			input.parentNode.removeChild(input);
			$('.introBlock__copyConfirm').fadeIn();
			setTimeout;
			setTimeout(function () {
				$('.introBlock__copyConfirm').fadeOut();
			}, 4000);
		});
	}
}
